// @ts-nocheck
/**
 * ドラフトシステム - 定数定義
 */

// ========================================
// 基本設定
// ========================================

export const DRAFT_CONFIG = {
  // 人数設定
  PLAYER_COUNT_OPTIONS: [4, 6, 8],
  DEFAULT_PLAYER_COUNT: 4,

  // パック設定
  PACK_SIZE: 12,

  // 人数別パック数
  PACKS_BY_PLAYER_COUNT: {
    4: 4,
    6: 4,
    8: 3,
  },

  // デッキ構築
  MIN_DECK_SIZE: 30,
  MAX_DECK_SIZE: 40,
  RECOMMENDED_DECK_SIZE: 35,

  // タイマー（秒）
  PICK_TIME_LIMIT: 30,
  DECK_BUILD_TIME_LIMIT: 300,
};

// ========================================
// パック構成
// ========================================

export const DRAFT_PACK_COMPOSITION = {
  // モンスター枠: 9枚
  monster: {
    total: 9,
    slots: [
      // 低コスト（1-2）: 3枚
      { costRange: [1, 2], rarity: 'C' },
      { costRange: [1, 2], rarity: 'C' },
      { costRange: [1, 2], rarity: 'C_UC' },
      // 中コスト（3-4）: 4枚
      { costRange: [3, 4], rarity: 'C_UC' },
      { costRange: [3, 4], rarity: 'C_UC' },
      { costRange: [3, 4], rarity: 'R_PLUS' },
      { costRange: [3, 4], rarity: 'R_PLUS' },
      // 高コスト（5+）: 2枚
      { costRange: [5, 10], rarity: 'R_PLUS' },
      { costRange: [5, 10], rarity: 'SR_PLUS' },
    ],
  },

  // 魔法枠: 2枚
  magic: {
    total: 2,
    slots: [
      { rarity: 'C_UC' },
      { rarity: 'R_PLUS' },
    ],
  },

  // フィールド/フェイズ枠: 1枚
  fieldOrPhase: {
    total: 1,
    fieldChance: 0.7,
    phaseChance: 0.3,
    slots: [
      { rarity: 'R_PLUS' },
    ],
  },
};

// ========================================
// レアリティスロット定義
// ========================================

export const DRAFT_RARITY_SLOTS = {
  // コモン確定
  C: {
    C: 1.0,
  },

  // コモン/アンコモン
  C_UC: {
    C: 0.70,
    UC: 0.30,
  },

  // レア以上
  R_PLUS: {
    R: 0.60,
    SR: 0.25,
    UR: 0.10,
    HR: 0.035,
    SEC: 0.010,
    ALT: 0.004,
    SP: 0.0016,
    GR: 0.0004,
  },

  // スーパーレア以上
  SR_PLUS: {
    SR: 0.50,
    UR: 0.30,
    HR: 0.15,
    SEC: 0.035,
    ALT: 0.012,
    SP: 0.0024,
    GR: 0.0006,
  },
};

// ========================================
// 経済設定
// ========================================

export const DRAFT_ECONOMY = {
  ENTRY_FEE: 15000,

  REWARDS: {
    4: {
      champion: { goldBonus: 10000, cardPicks: 5, packBonus: 2 },
      runnerUp: { goldBonus: 5000, cardPicks: 3, packBonus: 1 },
      semiFinal: { goldBonus: 2000, cardPicks: 1, packBonus: 0 },
    },
    6: {
      champion: { goldBonus: 15000, cardPicks: 6, packBonus: 2 },
      runnerUp: { goldBonus: 8000, cardPicks: 4, packBonus: 1 },
      semiFinal: { goldBonus: 4000, cardPicks: 2, packBonus: 1 },
      quarterFinal: { goldBonus: 2000, cardPicks: 1, packBonus: 0 },
    },
    8: {
      champion: { goldBonus: 20000, cardPicks: 8, packBonus: 3 },
      runnerUp: { goldBonus: 12000, cardPicks: 5, packBonus: 2 },
      semiFinal: { goldBonus: 6000, cardPicks: 3, packBonus: 1 },
      quarterFinal: { goldBonus: 3000, cardPicks: 2, packBonus: 0 },
    },
  },

  CONSOLATION: {
    goldBonus: 1000,
    cardPicks: 1,
  },
};

// ========================================
// ストレージ設定
// ========================================

export const DRAFT_STORAGE = {
  SESSION_KEY: 'magicSpirit_draft_session',
  HISTORY_KEY: 'magicSpirit_draft_history',
  SESSION_EXPIRY_DAYS: 7,
  MAX_SAVED_SESSIONS: 3,
};

// ========================================
// 保存トリガー
// ========================================

export const SAVE_TRIGGERS = {
  AUTO_SAVE: [
    'ROUND_COMPLETE',
    'PACK_COMPLETE',
    'DECK_BUILD_START',
    'DECK_CHANGE',
    'MATCH_COMPLETE',
  ],
  MANUAL_SAVE: true,
};

// ========================================
// ドラフトステータス
// ========================================

export const DRAFT_STATUS = {
  LOBBY: 'lobby',
  PICKING: 'picking',
  BUILDING: 'building',
  TOURNAMENT: 'tournament',
  FINISHED: 'finished',
};

// ========================================
// ドラフト方向
// ========================================

export const DRAFT_DIRECTION = {
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise',
};
